import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import React from "react";
// import { Label } from "react-bootstrap";
// import { Label } from "react-bootstrap";
// import { Label } from "reactstrap";
// import CustomTooltip from "../../Common/CustomTooltip";

function OverFlowLabel({ name, length = 20 }) {
  return (
    <>
      {name && (
        <>
          {name.length > length ? (
            <CustomTooltip tooltip={name}>
              <label className="data-label">{name} </label>
            </CustomTooltip>
          ) : (
            <label className="data-label">{name} </label>
          )}
        </>
      )}
    </>
  );
}

export default OverFlowLabel;
